import React from 'react';

const Rank = ({name, entries}) => {
    return (
        <div>
            <div className='white f3'>
                {`${name}, your current number of photo entries is ...`}
            </div>
            <div className='white f1'>
                {`${entries}`}
            </div>
        </div>
    );
};

export default Rank;


// WEBPACK FOOTER //
// ./src/components/Rank/Rank.js